<template>
  <div class="box" ref="box" @scroll="onScroll">
    <div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  emits: ["load"],
  props: {
    modelValue: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const onScroll = (e) => {
      let what = props.modelValue;
      // scrollTop 滚动高度 clientHeights 元素本身高度 clientHeight可以滚动高度
      let { scrollTop, clientHeight: clientHeights } = e.target;
      let { clientHeight } = e.currentTarget.lastElementChild;
      if (clientHeight <= scrollTop + clientHeights + 10) {
        if (!what) {
          // 更新加载状态
          emit("update:modelValue", true);
          // 发送需要加载了
          emit("loading");
        }
      }
    };
    return {
      onScroll,
    };
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  width: 100%;
  overflow: auto;
}
</style>
